import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateCalculationsModal({
  createInput,
  createCalculations,
  formData,
  setFormData,
  getCalculationsList,
  id,
  getCalculationsType,
  calculationsType,
}) {
  const setModal = useContext(ModalContext);

  let validation = {
    multiplier: 'text_underscore',
  };

  const validateForm = useFormValidator(formData, validation);

  useEffect(() => {
    if (_.get(formData, 'is_multiple')) {
      validation = {
        ...validation,
        multiplier: 'required|text_underscore',
      };
    }
    validateForm.onSetObjectRules(validation);
  }, [_.get(formData, 'is_multiple')]);

  useEffect(() => {
    setFormData({
      ...formData,
      multiplier: '',
    });
  }, [_.get(formData, 'tax_revenue_calculation_type_id')]);

  useEffect(() => {
    getCalculationsType();

    setFormData({
      for_new: true,
      for_renewal: true,
      multiplier: '',
    });
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      multiplier: _.get(formData, 'multiplier'),
      tax_revenue_calculation_type_id: _.get(
        formData,
        'tax_revenue_calculation_type_id'
      ),
      for_new: _.get(formData, 'for_new') ? _.get(formData, 'for_new') : false,
      for_renewal: _.get(formData, 'for_renewal')
        ? _.get(formData, 'for_renewal')
        : false,
    };

    createCalculations(id, args, () => {
      setModal({ isOpen: false });
      getCalculationsList(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const selectCalculationsType = calculationsType.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
    is_multiple: _.get(x, 'attributes.is_multiple'),
  }));

  const handleDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      is_multiple: e ? e.is_multiple : '',
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For New: &nbsp;
            </label>
            <input
              name="for_new"
              type="checkbox"
              checked={_.get(formData, 'for_new')}
              onChange={onChange}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">
              For Renewal: &nbsp;
            </label>
            <input
              name="for_renewal"
              type="checkbox"
              checked={_.get(formData, 'for_renewal')}
              onChange={onChange}
            />
          </div>

          <div className="col-12 form-group">
            <Select
              options={selectCalculationsType}
              placeholder="Select Calculation Type"
              onChange={handleDropDownChange('tax_revenue_calculation_type_id')}
            />
          </div>

          {_.get(formData, 'is_multiple') ? (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Multiplier: {validateForm.renderMessage('multiplier')}
              </label>
              <div className="">
                {createInput(
                  { key: 'multiplier' },
                  { placeholder: 'Ex. code_multiplier' }
                )}
              </div>
            </div>
          ) : (
            ' '
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary     mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateCalculationsModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getCalculationsList: PropTypes.instanceOf(Function).isRequired,
  createCalculations: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getCalculationsType: PropTypes.instanceOf(Function).isRequired,
  calculationsType: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  calculationsType:
    _.get(api, `${c.GET_CALCULATIONS_TYPE_SANITARY}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateCalculationsModal);
